<!--阅读拓展馆-->
<template>
    <div class="read_nav_content">
        <!-- 阅读拓展首页 -->
        <div class="read-ext-container" v-show="showMode==='homePage'">
            <div class="read-title-container">
                <div class="read-left-container" @click="backMuseum">
                    <svg v-show="this.isShowBack"  t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#0d55a4" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
                </div>
                <div class="read-right-container">恒岳·劳动实践馆</div>
                <div class="read-left-container">
                </div>
            </div>
            <div class="read-item-container">
                <div class="read-top-bottom-container">
                    <div class="read-container">
                        <div class="read-item" @click="viewReadModel('myjr')">
                            <div class="read-item-top">美育浸润</div>
                            <div class="read-item-bottom">系列视频资源</div>
                        </div>
                    </div>
                    <div class="read-container">
                        <div class="read-item" @click="viewPracticeModel">
                            <div class="read-item-top">非遗劳动实践</div>
                            <div class="read-item-bottom">主题活动</div>
                        </div>
                    </div>
                </div>
                <div class="read-top-bottom-container">
                    <div class="read-container">
                        <div class="read-item" @click="viewPageEvent('劳动实践主题班会','4')">
                            <div class="read-item-top">劳趣实践营</div>
                            <div class="read-item-bottom">劳动实践主题班会</div>
                        </div>
                    </div>
                    <div class="read-container">

                    </div>
                </div>
            </div>
        </div>

        <!-- 美育浸润 -->
        <div class="read_nav_content" v-show="showMode==='model-myjr'">
            <beauty-edu @back-read-museum="backReadMuseum" :mark-info="markInfo"/>
        </div>

        <!--劳动实践活动-->
        <div class="read_nav_content" v-show="showMode==='practicePage'">
            <practice-home @back-model-page="backModelPage"/>
        </div>

        <!--研学实践-->
        <div class="read_nav_content" v-show="showMode==='museumEventPage'">
<!--            <page-museum-event :item-id="itemId"-->
<!--                               :item-name="itemName"-->
<!--                               :mark-info="this.markInfo"-->
<!--                               @back-model-page="backModelPage"/>-->
            <book-reading-club :museum-id="this.museumId"
                               :mark-info="this.markInfo"
                               @back-read-museum="backModelPage"/>
        </div>

    </div>
</template>

<script>
import {serviceUrl} from "@/utils/global";
import beautyEdu from "@/components/newMuseum/read/beautyEdu.vue";
import pageMuseumEvent from "@/components/newMuseum/event/pageMuseumEvent.vue";
import practiceHome from "@/components/newMuseum/practice/practiceHome.vue";
import BookReadingClub from "@/components/newMuseum/read/bookReadingClub.vue";

export default {
    name: "laborPracticeMuseum",
    components: {BookReadingClub, pageMuseumEvent, beautyEdu,practiceHome},
    data() {
        return {
            showMode:'homePage',
            baseMode:'model-',
            serviceUrl,
            itemId:'',
            itemName:'恒岳科创会',
            markInfo:'museumEventPage',
            museumMode:"",
            museumId:"",
        }
    },
    computed: {},
    props:{
        isShowBack:{
            type: Boolean,
            default:true
        },
    },
    watch: {
        isShowBack(newValue,oldValue){
        },
    },
    created() {
    },
    mounted(){},
    methods: {
        backModelPage(val){
            this.showMode = "homePage";
        },
        viewPageEvent(title,key){
            this.markInfo = new Date();
            this.museumId = '4';
            this.showMode = 'museumEventPage';
        },
        viewPracticeModel(){
            this.showMode = 'practicePage';
        },
        /*返回五馆首页*/
        backMuseum(){
            this.$emit('child-back-museum', "page");
        },
        /*查看阅读馆模块*/
        viewReadModel(val){
            this.markInfo = 'time-'+new Date();
            this.showMode =  this.baseMode+val;
        },
        /*从子模块阅读馆*/
        backReadMuseum(val){
            this.showMode = val;
        }
    }
}
</script>
<style scoped>
.read_nav_content{
    width: 100%;
    height: auto;
}
.read-ext-container{
    width: 100%;
    height: calc(100vh - 90px);
    background-color: #fff;
    padding-bottom: 10px;
    box-sizing: border-box;
}
.read-title-container{
    width: 100%;
    height: 44px;
    display: flex;
}
.read-left-container{
    width: 200px;
    height: 44px;
    cursor: pointer;
    padding-left: 10px;
    padding-top: 9px;
}
.read-right-container{
    width: calc(100% - 400px);
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #0d55a4;
    line-height: 44px;
    font-weight: bold;
}
.read-item-container{
    width: 100%;
    height: calc(100% - 50px);
    padding: 50px 40px 50px 40px;
    box-sizing: border-box;
}
.read-top-bottom-container{
    width: 100%;
    height: 50%;
    display: flex;
}
.read-container{
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.read-item{
    width: 70%;
    height: 140px;
    border: 1.5px solid #0d55a4;
    box-sizing: border-box;
    border-radius: 3px;
    cursor: pointer;
    color: #0d55a4;
}
.read-item:hover{
    color: #fff!important;
    background-color: #0d55a4;
}
.read-item-top{
    width: 100%;
    height: 75px;
    text-align: center;
    font-size: 18px;
    line-height: 100px;
    font-weight: bold;
}
.read-item-bottom{
    width: 100%;
    height: 65px;
    text-align: center;
    font-size: 16px;
}
</style>